<template>
  <div>
    <v-row>      
      <v-col cols="12">
        <h2>Allergies</h2>
        <br>
        <hr>
        
        <table class="notes-customized">
          <thead>
            <tr>
              <th align="left" style="width: 40%">Allergy</th>
              <th align="left" style="width: 60%">Note</th>
            </tr>
          </thead>
          <tbody v-if="form.allergies.length">
            <tr v-for="(item, key) in form.allergies" :key="key">
              <td style="width: 40%">{{ item.Allergy }}</td>
              <td style="width: 60%; white-space: pre;">{{ item.Note }}</td>
            </tr>
          </tbody>
          <!-- Empty Table -->
          <div v-else class="d-flex justify-center align-center w-100" style="min-height: 100px; width: 100%;">
            <span>No data available</span>
          </div>
        </table>

      </v-col>

      <v-col cols="12">
        <h2>Case Notes</h2>
        <br>
        <hr>
          <table class="notes-customized">
            <thead>
              <tr>
                <th align="left" style="width: 40%">Title</th>
                <th align="left" style="width: 60%">Notes</th>
              </tr>
            </thead>
            <tbody v-if="form.notes.length">
              <tr v-for="(item, key) in form.notes" :key="key">
                <td style="width: 40%">{{ item.Title }}</td>
                <td style="width: 60%; white-space: pre;">{{ item.NoteText }}</td>
              </tr>
            </tbody>
            <!-- Empty Table -->
            <div v-else class="d-flex justify-center align-center w-100" style="min-height: 100px; width: 100%;">
              <span>No data available</span>
            </div>
          </table>

          <p>&nbsp;</p>
          <hr>
          <p>&nbsp;</p>


          <!-- <base-table
            :headers="headers"
            :items="form.notes"
          >
            <template v-slot:item="{ item, index }">
              <tr :id="'note-instance-' + index" @click="updateNote(index)">
                <td>
                  <v-text-field
                    v-model="item.Title"
                    placeholder=" "
                    class="primary-label"
                  >
                    <template v-slot:label>
                      <span class="font-weight-bold">Title</span>
                    </template>
                  </v-text-field>

                </td>
                <td>

                  <v-textarea
                    v-model="item.NoteText"
                    placeholder=" "
                    class="primary-label"
                  >
                    <template v-slot:label>
                      <span class="font-weight-bold">Notes</span>
                    </template>
                  </v-textarea>

                </td>
              </tr>
            </template>
          </base-table> -->



      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'TMAHealthInformation',

  props: {
    form: {
      type: Object,
    },
  },

  /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

  data: ()=> ({
    /*caseInfo: {},
    form: {},*/
    headers: [
      { text: '', value: 'title', class:'primary--text' },
      { text: '', value: 'note', class:'primary--text' },
    ],
  }),

  /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

  watch: {
    form: {
      handler: function(value) {
        console.log("health information")
        console.log(value);
      },
      deep: true
    },
  },

  /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

  methods: {
    async retrieveCaseImages() {
      console.log("case_number here health information");
      console.log(this.form.pmsCaseNumber);
      await this.$store.dispatch('cases/getImageToken', this.form.pmsCaseNumber);
      return false;
    },
  },

  /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

  mounted() {
  }
};
</script>

<style type="text/css">
  .notes-customized {
    padding-bottom: 10px;
    width:  100%;
  }

  .notes-customized th {
    background: #eee;
    color: #258bf5 !important;
    padding: 5px;
  }

  .notes-customized tr td { padding: 5px; }

  .notes-customized tr:nth-child(even) td {
    background:  #e6e6e6;
  }

  .notes-customized tr:nth-child(odd) td {
    background:  #f6f6f6;
  }

</style>